class MFRHostedVideo {
  constructor(index, element) {
    this.$index = index;
    this.$element = $(element);

    this.init();
  }

  init() {
    this.$video = this.$element.find("video");

    this.$video.on("play", this.__handleVideoPlay.bind(this));
    this.$video.on("pause", this.__handleVideoPause.bind(this));

    this.$video.on("click", this.__handleVideoClick.bind(this));
  }

  __handleVideoPlay(e) {
    this.$element.toggleClass("is-playing", !e.currentTarget.paused);
  }

  __handleVideoPause(e) {
    this.$element.toggleClass("is-playing", !e.currentTarget.paused);
  }

  __handleVideoClick(e) {
    if ($(e.currentTarget).attr("controls")) return;

    if (e.currentTarget.paused) e.currentTarget.play();
    else e.currentTarget.pause();
  }
}
